import React from 'react';
import { WifiOffIcon, SmartphoneIcon, GlobeIcon, ShieldIcon, ZapIcon, BarChartIcon } from 'lucide-react';
const Features = () => {
  const features = [{
    icon: <WifiOffIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-33" />,
    title: 'Works Offline',
    description: 'Access AI without internet connection through voice calls or SMS text.'
  }, {
    icon: <SmartphoneIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-34" />,
    title: 'No Smartphone Required',
    description: 'Works on any basic phone with calling or texting capabilities.'
  }, {
    icon: <GlobeIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-35" />,
    title: 'Accessible',
    description: 'Available wherever there is mobile network coverage'
  }, {
    icon: <ShieldIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-36" />,
    title: 'Local Telephone Number',
    description: 'Uses an approved/trusted number from local telecom vendors.'
  }, {
    icon: <ZapIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-37" />,
    title: 'Quick Branded Deployment',
    description: 'Ready-to-deploy AI product that can be white-labeled and launched in under a month.'
  }, {
    icon: <BarChartIcon className="h-8 w-8 text-[#54d4cb]" data-id="element-38" />,
    title: 'High Engagement',
    description: 'Users average 20+ interactions per day, driving telecom usage.'
  }];
  return <section id="features" className="py-16 bg-gray-50" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="text-center mb-16" data-id="element-41">
          <h2 className="text-3xl font-bold mb-4" data-id="element-42">
            Making AI Accessible To Everyone
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-43">
            Voxie bridges the digital divide by bringing AI capabilities to the
            next billion users who currently can't access it due to
            connectivity, device limitations or digital proficiency.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-44">
          {features.map((feature, index) => <div key={index} className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow" data-id="element-45">
              <div className="mb-4" data-id="element-46">{feature.icon}</div>
              <h3 className="text-xl font-semibold mb-2" data-id="element-47">{feature.title}</h3>
              <p className="text-gray-600" data-id="element-48">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
};
export default Features;